import { AfterViewInit, Component, ElementRef, Injector, NgZone, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { filter, take } from 'rxjs/operators';

import { WebcomponentsService } from '@core/service/webcomponents.service';
import { AuthService } from '@auth/auth.service';
import {
  MESSAGE_ALGO_SALIO_MAL,
  show_popup,
  showPopupBase,
  TITLE_ERROR,
  TITLE_MENSAJE,
} from '@shared/utility/popup-error';
import { ROUTES_CONSTANTS } from '@shared/configs';

import { PRODUCT_APPLICATION_STATE_CONSTANT, ProductType, SCREEN_TYPE_CONSTANTS } from '@core/model/enums';

@Component({
  selector: 'app-refinance-loan',
  templateUrl: './refinance-loan.component.html',
})
export class RefinanceLoanComponent implements AfterViewInit {
  @ViewChild('refinanceLoanRef') public refinanceLoanRef: ElementRef;
  public refinanceLoanRefInstance: { build: Function; destroy: Function };

  protected readonly ngZone: NgZone;

  private readonly webElementService: WebcomponentsService;
  private readonly router: Router;
  private readonly authService: AuthService;

  constructor(private readonly injector: Injector) {
    this.webElementService = this.injector.get(WebcomponentsService);
    this.router = this.injector.get(Router);
    this.ngZone = this.injector.get(NgZone);
    this.authService = this.injector.get(AuthService);
  }

  public ngAfterViewInit(): void {
    this.loadRefinanceLoanRef();
  }

  public loadRefinanceLoanRef(): void {
    this.webElementService.isLoaded$.pipe(filter(Boolean), take(1)).subscribe({
      next: (loaded: boolean) => {
        if (loaded) {
          const token = this.authService?.token;
          const clientId = this.authService?.getTokenData(token).clienteId;
          this.refinanceLoanRefInstance = this.refinanceLoanRef.nativeElement._ngElementStrategy?.componentRef.instance;
          this.refinanceLoanRefInstance.build({
            manageApplicationResponseFn: this.manageApplicationResponseFn.bind(this),
            showErrorPopUpFn: this.showErrorPopUpFn.bind(this),
            clientId,
          });
        }
      },
    });
  }

  private manageApplicationResponseFn(result): void {
    this.ngZone.run(() => {
      if (result?.response?.state === PRODUCT_APPLICATION_STATE_CONSTANT.RET_RP.ON_PROCESS) {
        this.router.navigate([ROUTES_CONSTANTS.DISPERSION_METHOD]);
      } else if (result?.response?.state === PRODUCT_APPLICATION_STATE_CONSTANT.RET_RP.DECLINED) {
        this.router.navigate([ROUTES_CONSTANTS.REJECTED], {
          queryParams: { productType: ProductType.RETRP, screenType: SCREEN_TYPE_CONSTANTS.REJECTED },
        });
      } else if (result?.response?.state === PRODUCT_APPLICATION_STATE_CONSTANT.RET_RP.CANCELED) {
        this.router.navigate([ROUTES_CONSTANTS.APPLICATION_REJECTION], {
          queryParams: {
            productType: ProductType.RETRP,
            screenType: SCREEN_TYPE_CONSTANTS.CANCELED,
          },
        });
      } else if (result?.response?.navigableResponseDto.message) {
        showPopupBase(TITLE_MENSAJE, result.response.navigableResponseDto.message).then(() => {
          this.router.navigate([ROUTES_CONSTANTS.APPLICATION_REJECTION]);
        });
      }
    });
  }

  private showErrorPopUpFn(): void {
    show_popup(TITLE_ERROR, MESSAGE_ALGO_SALIO_MAL);
  }
}
